/** Finger travel before a touch commits to an axis; below it a tap and a pull look alike. */
export const PULL_START = 8;
/** Indicator travel that arms the refresh. */
export const PULL_THRESHOLD = 48;
/** Indicator travel is capped so the pull feels elastic rather than tied to the finger. */
export const PULL_MAX = 96;
/** Where the indicator rests while the sync runs. */
export const PULL_REST = 56;

const PULL_RATIO = 0.7;

/** The axis a touch has committed to, or null while it is still ambiguous. */
export function pullAxis(dx: number, dy: number): 'x' | 'y' | null {
  if (Math.abs(dx) < PULL_START && Math.abs(dy) < PULL_START) return null;
  return Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
}

/** Indicator travel for a downward finger travel of `dy` pixels. */
export function pullDistance(dy: number): number {
  const d = Math.max(0, dy - PULL_START) * PULL_RATIO;
  return PULL_MAX * (1 - Math.exp(-d / PULL_MAX));
}
